<template>
    <div class="person_block_column">
        <div class="person_block">
            <div class="person_image">
                <div
                    v-full-background-image-path="person.featuredImage"
                    class="image bg_image cover"
                />

                <div class="icon_wrapper">
                    <div class="icon">
                        <picture v-full-image-path:assets="'campus_icon.svg'" />
                    </div>
                </div>
            </div>

            <div class="details_top">
                <div class="details">
                    <div class="person_name">
                        {{ person.fullName }}
                    </div>

                    <div class="specialization">
                        {{ person.position }}
                    </div>
                </div>
            </div>

            <div class="details_bottom">
                <a class="btn_email" @click="$emit('contact-us', person.email)">
                    צור קשר
                </a>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        person: {
            type: Object,
            required: true
        }
    }
};
</script>
